<div class="faq-container" *transloco="let t; prefix: 'faq'">
  <h2>Frequently asked questions</h2>

  @for (config of triggerConfigs(); track $index; let i = $index) {
    <accredible-expansion-panel [triggerConfig]="config">
      <div expansionPanelHeader>
        {{ t('questions.q' + (i + 1)) }}
      </div>
      <div>
        {{ t('answers.a' + (i + 1)) }}
      </div>
    </accredible-expansion-panel>
  }
</div>
